import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const ShopHome = lazyWithRetry(() => import('../../pages/Shop/ShopHome'));

export const routes: RouteObject[] = [
  { index: true, element: <ProtectedRoute><ShopHome /></ProtectedRoute> },
];
